import cloneDeep from 'lodash.clonedeep';

export namespace FilterOptionsUtil {
  export function formatFilterOptions(options: any): any {
    const clonedOptions = cloneDeep(options);

    Object.keys(clonedOptions).forEach(optionKey => {
      clonedOptions[optionKey] = Array.isArray(clonedOptions[optionKey])
        ? {...clonedOptions[optionKey]}
        : clonedOptions[optionKey];
    });

    return clonedOptions;
  }
}
